module.exports = __webpack_public_path__ + "static/img/jjfa1.6acfbd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jjfa1.jpg
// module id = iRJG
// module chunks = 1